import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { ApiService } from '../api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Panel } from 'src/app/model/panel-modal/panel-model';
import { Candidate } from 'src/app/model/candidate.model';
import { PanelMember } from 'src/app/model/panel-member.model';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PanelService {

  private _panelMembersSource = new BehaviorSubject('default message');
  panelMember$ = this._panelMembersSource.asObservable();

  private _selectedCandidatesSource = new BehaviorSubject('default message');
  selectedCandidates$ = this._selectedCandidatesSource.asObservable();

  constructor(private http: Http, private apiService: ApiService) { }
  private apiDomain = ApiService.getDomainName();

  form: FormGroup = new FormGroup({
    id: new FormControl(null),
    panelName: new FormControl('', [Validators.required, Validators.minLength(1)]),
    roomIdentification: new FormControl('', [Validators.required, Validators.minLength(1)]),
    panelMembers: new FormControl('', Validators.required),
    candidates: new FormControl('', Validators.required),
    meetingLink: new FormControl(null, Validators.pattern('(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})')),
  });
  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error._body);
    }
  }

  sendPanelValues(panels: any) {
   this._panelMembersSource.next(panels);
  }

  sendCandidatesValue(cand: any) {
    this._selectedCandidatesSource.next(cand);
  }
  
  findAll(processId): Promise<Array<Panel>> {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/" + processId + "/panel/", { headers })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);
  }
  findById(panelId) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/panel/" + panelId, { headers })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  createPanel(panel: Panel, processId): Promise<Array<Panel>> {
    let panelHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    let dataObj = JSON.stringify(panel);
    return this.http.post(this.apiDomain + "/ims/api/" + processId + "/panel/", dataObj, { headers: panelHeaders })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);
  }

  updatePanel(panel: Panel, panelId) {
    let panelHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/panel/" + panelId, JSON.stringify(panel), { headers: panelHeaders })
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  deletePanel(id) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() })
    const url = this.apiDomain + "/ims/api/panel/" + id
    return this.http.delete(url, { headers })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);
  }

  panelAssigning(panelId) {
    let panelAssigning = new Headers({ 'feedbackUrl': `${ApiService.selfDomain}/panelAssigning/` + panelId, 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/sendmail/" + panelId, { headers: panelAssigning })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);

  }

  availableCandidate(procressId) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/" + procressId + "/availableCandidate/", { headers })
      .toPromise()
      .then(response => response.json() as Candidate[])
      .catch(this.handleError);
  }

  availablePanelMember(procressId) {
    const headers = new Headers({'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/" + procressId + "/availablePanelMember/", { headers })
      .toPromise()
      .then(response => response.json() as PanelMember[])
      .catch(this.handleError);
  }

  addMoreCandidates(jsonObject: any, panelId): Promise<Array<Panel>> {
    let panelHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/panel/" + panelId + "/addMoreCandidates", jsonObject, { headers: panelHeaders })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);
  }

  notificationEmailAndSmsForCandidate(candidateIdArray: any, panelId) {
    let notification = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.post(this.apiDomain + "/ims/api/sendMailandSms/candidate/" + panelId, candidateIdArray, { headers: notification })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);

  }

  notificationEmailAndSmsForPanelMember(panelId) {
    let panelAssigning = new Headers({ 'feedbackUrl': `${ApiService.selfDomain}/panelAssigning/` + panelId, 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/sendmail/" + panelId, { headers: panelAssigning })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);
  }

  fetchMeetingLink(meetingLinkProvider: String): any {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'authorization': this.apiService.getStringifySessionObj()
    });

    return this.http.get(`${this.apiDomain}/ims/api/meetingLink/create?service=${meetingLinkProvider}`, {headers})
              .toPromise()
              .then(response => response.json())
              .catch(this.handleError);
  }
}
